<template>
  <div>
    <app-header></app-header>
    <router-view></router-view>
    <app-footer></app-footer>
  </div>
</template>

<script>
import appHeader from '../header/index.vue';
import appFooter from '../footer/index.vue'
export default {
  name: 'Main',
  components: { appFooter, appHeader },
}
</script>
